
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"5","fill":"#E6F6F0"}}),_c('rect',{attrs:{"x":"21","y":"9","width":"3","height":"3","rx":"1","fill":"#00A769"}}),_c('rect',{attrs:{"x":"7","y":"9","width":"12","height":"3","rx":"1","fill":"#00A769"}}),_c('rect',{attrs:{"x":"21","y":"14","width":"3","height":"3","rx":"1","fill":"#00A769"}}),_c('rect',{attrs:{"x":"7","y":"14","width":"12","height":"3","rx":"1","fill":"#00A769"}}),_c('rect',{attrs:{"x":"21","y":"19","width":"3","height":"3","rx":"1","fill":"#00A769"}}),_c('rect',{attrs:{"x":"7","y":"19","width":"12","height":"3","rx":"1","fill":"#00A769"}})])
          )
        }
      }
    